// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tNMbWGPG2cxWcJrwYZqB{flex-direction:column;gap:24px;display:flex}.iyH1OYZqBr4BUnym_7_0{flex-direction:column;gap:10px;display:flex}.o5uxkN3UeocbWTUMIABz{justify-content:flex-end;gap:8px;padding-top:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `tNMbWGPG2cxWcJrwYZqB`,
	"notification": `iyH1OYZqBr4BUnym_7_0`,
	"actions": `o5uxkN3UeocbWTUMIABz`
};
export default ___CSS_LOADER_EXPORT___;
